/**
 * Created by wupeng on 2019/8/9.
 */
import HeaderPaddingMain from '@/views/layout/HeaderPaddingMain.vue';
var router = [{
  path: '/roleSetting',
  component: HeaderPaddingMain,
  name: 'roleSetting',
  meta: {
    title: '角色设置',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/teacher/RoleSetting.vue');
    }
  }]
}, {
  path: '/personImport',
  component: HeaderPaddingMain,
  name: 'personImport',
  meta: {
    title: '人员导入',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/person/PersonImport.vue');
    }
  }]
}, {
  path: '/personDetail',
  component: HeaderPaddingMain,
  name: 'personDetail',
  meta: {
    title: '人员详情',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/person/personDetail.vue');
    }
  }]
}];
export default router;